/* sugar:assets/collection-navigation.js@2.1.7 */
/*
 * Collection Navigation — one list of items, a free-drag Splide slider where a layout asks for it.
 *
 * The section renders the same markup for every viewport. On mobile, when the section's
 * mobile layout is "slider", and on desktop, when its desktop layout is "scroll", Splide mounts
 * on the <nav> and starts on the active item so the collection being viewed is in view. Every
 * other layout mounts nothing and the stylesheet lays the list out (a wrapping row, or a row
 * whose items share the width). The two sliders differ only in the track padding, which the
 * stylesheet's pre-mount row matches: 1.5rem on phones, 6px on desktop.
 */
(function () {
  'use strict';

  if (window.SugarCollectionNav) return;

  var MOBILE = '(max-width: 749px)';
  var RETRY_MS = 100;
  var mq = window.matchMedia(MOBILE);

  function mount(nav, mode, gap) {
    if (nav._splide && nav._cnMode === mode) return true;
    if (typeof Splide === 'undefined') return false;
    if (nav._splide) unmount(nav);

    var start = parseInt(nav.getAttribute('data-start') || '0', 10) || 0;
    var pad = mode === 'desktop' ? '6px' : '1.5rem';

    var instance;
    try {
      instance = new Splide(nav, {
        type: 'slide',
        drag: 'free',
        snap: false,
        autoWidth: true,
        gap: gap + 'px',
        arrows: false,
        pagination: false,
        trimSpace: true,
        focus: 'center',
        start: start,
        padding: { left: pad, right: pad }
      });
      instance.mount();
    } catch (e) {
      return true;
    }
    nav._splide = instance;
    nav._cnMode = mode;
    return true;
  }

  function unmount(nav) {
    if (!nav._splide) return;
    nav._splide.destroy(true);
    nav._splide = null;
    nav._cnMode = null;
    // destroy() leaves is-initialized / is-overflow on the root, and the vendor stylesheet
    // turns an initialized-but-inactive list into a block. Strip every state class.
    Array.prototype.slice.call(nav.classList).forEach(function (c) {
      if (c.indexOf('is-') === 0 || c.indexOf('splide--') === 0) nav.classList.remove(c);
    });
  }

  var pending = false;

  function init(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    var navs = Array.prototype.slice.call(host.querySelectorAll('[data-collection-nav]'));
    var ready = true;
    var onMobile = mq.matches;
    var mode = onMobile ? 'mobile' : 'desktop';

    // Read every nav first, then mount or tear down, so one nav's mount never forces a
    // layout before the next is measured.
    var plans = navs.map(function (nav) {
      var want = onMobile
        ? nav.getAttribute('data-mobile-layout') === 'slider'
        : nav.getAttribute('data-desktop-layout') === 'scroll';
      var gap = want ? parseInt(getComputedStyle(nav).getPropertyValue('--cn-gap'), 10) || 8 : 0;
      return { nav: nav, want: want, gap: gap };
    });

    plans.forEach(function (plan) {
      if (plan.want) {
        if (!mount(plan.nav, mode, plan.gap)) ready = false;
      } else {
        unmount(plan.nav);
      }
    });

    if (!ready && !pending) {
      pending = true;
      setTimeout(function () {
        pending = false;
        init(scope);
      }, RETRY_MS);
    }
  }

  window.SugarCollectionNav = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  var onChange = function () {
    init(document);
  };
  if (mq.addEventListener) {
    mq.addEventListener('change', onChange);
  } else if (mq.addListener) {
    mq.addListener(onChange);
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  }
})();
